import { useEffect, useState } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import "./swagger-ui-generator.css";

export default function SwaggerUIGenerator() {
  const [url, setUrl] = useState("");

  useEffect(() => {
    const url = new URL(window.location.href.replace("#", "?"));
    const params = new URLSearchParams(url.search);
    setUrl(params.get("url") ?? "");
  }, []);

  if (!url) return <></>;

  return <SwaggerUI {...{ url }} />;
}
